import { todayWithSystemTimeZone } from '@magicdoorinc/date';
import { ReconciliationItemStatus, ReconciliationPeriodStatus } from '~/swagger/accounting/Api';
import type { ReconciliationResolutionType, ReconciliationReviewReason } from '~/swagger/accounting/Api';

export const defaultOccurredStartDate = (): string => todayWithSystemTimeZone().subtract(3, 'month').startOf('month').format('YYYY-MM-DD');

export const isValidOccurredDateRange = (occurredStart?: string, occurredEnd?: string): boolean => {
  if (!occurredStart || !occurredEnd) return true;
  return occurredStart <= occurredEnd;
};

export type OccurredDateFilterBounds = {
  occurredStart?: string;
  occurredEnd?: string;
};

export type NonDateItemFilters = {
  statuses?: ReconciliationItemStatus[];
  resolutionTypes?: ReconciliationResolutionType[];
  reviewReasons?: ReconciliationReviewReason[];
};

export const withPreservedDateFilters = (
  current: OccurredDateFilterBounds,
  next: NonDateItemFilters
): OccurredDateFilterBounds & NonDateItemFilters => {
  const result: OccurredDateFilterBounds & NonDateItemFilters = { ...next };
  if (current.occurredStart) result.occurredStart = current.occurredStart;
  if (current.occurredEnd) result.occurredEnd = current.occurredEnd;
  return result;
};

export const canExpandPeriodReconciliationItem = (args: {
  periodStatus: ReconciliationPeriodStatus;
  itemStatus: ReconciliationItemStatus;
  reconciliationItemId?: string;
}): boolean => {
  if (args.periodStatus !== ReconciliationPeriodStatus.Draft && args.periodStatus !== ReconciliationPeriodStatus.Reopened) {
    return false;
  }
  if (!args.reconciliationItemId) return false;
  return args.itemStatus === ReconciliationItemStatus.Open || args.itemStatus === ReconciliationItemStatus.NeedsReview;
};
